module.exports = __webpack_public_path__ + "static/media/37.5f9d7f23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/37.jpg
// module id = 570
// module chunks = 0